document.addEventListener("DOMContentLoaded", function () {
  let current_Smoothie;
  const DOM = {};
  DOM.shape = document.querySelector("svg.shape");
  DOM.path = DOM.shape.querySelector("path");
  const closePop = document.querySelector("#close-pop");
  const detailPop = document.querySelector("#detail-pop");

  if (closePop) {
    closePop.addEventListener("click", () => {
      console.log("closePop");
      document.body.style.overflow = "auto";
      current_Smoothie.classList.remove("active");

      anime({
        targets: DOM.shape,
        height: "20vh",
        duration: 50,
        easing: "easeInQuad",
      });

      anime({
        targets: DOM.path,
        duration: 50,
        easing: "easeOutQuad",
        d: DOM.path.getAttribute("d"),
      });

      detailPop.classList.remove("active");
    });
  }

  document.querySelectorAll("#blog-Smoothie .thumb").forEach((elm) => {
    elm.addEventListener("click", () => {
      current_Smoothie = elm;
      detailPop.classList.add("active");
      detailPop.style.background = "none";
      document.body.style.overflow = "hidden";
      elm.classList.add("active");
      const holder = document.querySelector("#detail-pop .holder");
      while (holder.firstChild) {
        holder.removeChild(holder.firstChild);
      }
      const clonedElm = elm.parentNode.querySelector(".full").cloneNode(true);
      holder.append(clonedElm);

      const dphc = "." + elm.dataset.color;
      const currentColorElem = document.querySelector(dphc);
      if (currentColorElem) {
        const dpbc = window
          .getComputedStyle(currentColorElem)
          .getPropertyValue("background-color");
        document.querySelector(".shape").style.fill = dpbc;
      }

      const currentContent = document.querySelector(
        "#detail-pop .recipe-visual"
      );
      if (currentContent) {
        const dpfill = window
          .getComputedStyle(currentContent)
          .getPropertyValue("fill");
        document.querySelector("#honor").style.fill = dpfill;
        document.querySelector("#close-pop").style.color = dpfill;
      }
      let rd = 550;

      if (window.innerWidth < 768) {
        rd = 0;
      }
      anime({
        targets: DOM.shape,
        height: "400vh",
        duration: 1050,
        easing: "easeInQuad",
      });
      anime({
        targets: DOM.path,
        duration: 1050,
        easing: "easeOutQuad",
        d: DOM.path.getAttribute("pathdata:id"),
      });
      anime({
        targets: ".holder .recipe .recipe-visual .smoothie-image",
        duration: 550,
        easing: "easeInOutQuad",
        scale: [0, 1],
        rotate: [-10, 10],
        delay: 200,
      });
      anime({
        targets: ".holder .recipe .recipe-info",
        duration: rd,
        easing: "easeInOutQuad",
        translateX: ["-50vw", 0],
        delay: 800,
      });
      anime({
        targets: "#honor",
        duration: 200,
        easing: "easeInOutQuad",
        opacity: [0, 1],
        complete: function () {
          float();
        },
        delay: 1000,
      });
      detailPop.classList.add("active");
      current_Smoothie.classList.add("active");
    });
  });
  function float() {
    anime({
      targets: ".holder .recipe .recipe-visual .smoothie-image",
      translateY: "-3vh",
      duration: 2000,
      loop: true,
      direction: "alternate",
      easing: "linear",
    });
  }
});
